








import { Vue, Prop, Component } from "vue-property-decorator";
import '../../../../assets/iconfont.css';
import { jsPlumbInstance } from 'jsplumb';

@Component
export default class ZoomControl extends Vue {
  @Prop()
  private jsplumbInstance!: jsPlumbInstance;
  @Prop()
  private drawLayerDom!: HTMLElement;

  private defaultIncrement = 10; // 默认增量
  private zoomRate = 100; // 缩放比例 默认100
      // 放大缩小按钮禁用
  private addDisabled = false;
  private minusDisabled = false;

  private change(delta: number) {
    let zoomRate = this.zoomRate + delta;
    if (zoomRate < 50) {
      zoomRate = 50;
      this.minusDisabled = true;
    } else if (zoomRate > 200) {
      zoomRate = 200;
      this.addDisabled = true;
    } else {
      this.addDisabled = false;
      this.minusDisabled = false;
    }
    this.zoomRate = zoomRate;
    // this.$emit('zoom-change', zoomRate / 100);
    const zoom = zoomRate / 100;
    this.drawLayerDom.style.transform = `scale(${zoom})`;
    this.jsplumbInstance.setZoom(zoom);
  }
}
